// QR Menü Tema Presetleri (44 tema)
// Her tema CSS değişkenlerine maplenir: --qm-primary, --qm-bg, vb.
// QRMenu.js root'unda style olarak inject edilir.
//
// NOT: `font` = başlık (heading/decorative) fontu — h1/h2/h3'te kullanılır.
//      `bodyFont` = gövde metni fontu — okunabilir sans/serif, paragraf ve buton vb.

export const QR_MENU_THEMES = [
  // ─── KLASİK / RESTORAN ───
  {
    id: 'classic-cream',
    name: 'Klasik Krem',
    category: 'classic',
    primary: '#8B4513',
    secondary: '#D2691E',
    accent: '#FFB347',
    bg: '#FFF8E7',
    surface: '#FFFFFF',
    text: '#2C1810',
    textMuted: '#6B5345',
    font: 'Playfair Display',
    bodyFont: 'Lora',
    layout: 'list',
    headerStyle: 'centered-serif',
    cardStyle: 'classic-border',
    cardVariant: 'paper',
    borderRadius: '4px',
    shadow: 'sm',
  },
  {
    id: 'royal-emerald',
    name: 'Asil Zümrüt',
    category: 'classic',
    primary: '#0F5132',
    secondary: '#198754',
    accent: '#D4AF37',
    bg: '#F5F2E8',
    surface: '#FFFFFF',
    text: '#1A1A1A',
    textMuted: '#555555',
    font: 'Cinzel',
    bodyFont: 'Lora',
    layout: 'grid',
    headerStyle: 'gold-divider',
    cardStyle: 'gold-frame',
    cardVariant: 'art-deco',
    borderRadius: '2px',
    shadow: 'md',
  },
  {
    id: 'vintage-burgundy',
    name: 'Vintage Bordo',
    category: 'classic',
    primary: '#722F37',
    secondary: '#A23B47',
    accent: '#E8B4B8',
    bg: '#F9F4F0',
    surface: '#FFFCF8',
    text: '#2B1418',
    textMuted: '#7A5A60',
    font: 'Cormorant Garamond',
    bodyFont: 'Merriweather',
    layout: 'list',
    headerStyle: 'vintage-ornament',
    cardStyle: 'subtle-divider',
    cardVariant: 'editorial',
    borderRadius: '0px',
    shadow: 'sm',
  },
  {
    id: 'marble-gold',
    name: 'Mermer Altın',
    category: 'classic',
    primary: '#B8860B',
    secondary: '#DAA520',
    accent: '#F5E6CA',
    bg: '#FAFAF7',
    surface: '#FFFFFF',
    text: '#1F1F1F',
    textMuted: '#666666',
    font: 'Cinzel',
    bodyFont: 'Lato',
    layout: 'grid',
    headerStyle: 'marble-bg',
    cardStyle: 'thin-gold',
    cardVariant: 'art-deco',
    borderRadius: '8px',
    shadow: 'lg',
  },
  {
    id: 'dark-elegance',
    name: 'Karanlık Zarafet',
    category: 'classic',
    dark: true,
    primary: '#C9A961',
    secondary: '#E8C880',
    accent: '#FFFFFF',
    bg: '#1A1A1A',
    surface: '#2A2A2A',
    text: '#F5F5F5',
    textMuted: '#A0A0A0',
    font: 'Playfair Display',
    bodyFont: 'Lato',
    layout: 'list',
    headerStyle: 'gold-underline',
    cardStyle: 'dark-card',
    cardVariant: 'art-deco',
    borderRadius: '6px',
    shadow: 'xl',
  },
  {
    id: 'mediterranean-blue',
    name: 'Akdeniz Mavisi',
    category: 'classic',
    primary: '#005A8B',
    secondary: '#0077B5',
    accent: '#F4D03F',
    bg: '#F0F8FF',
    surface: '#FFFFFF',
    text: '#0A2540',
    textMuted: '#5A7A95',
    font: 'Lato',
    bodyFont: 'Lato',
    layout: 'grid',
    headerStyle: 'wave-bottom',
    cardStyle: 'rounded-soft',
    cardVariant: 'glass',
    borderRadius: '12px',
    shadow: 'md',
  },

  // ─── KAFE / COFFEE SHOP ───
  {
    id: 'coffee-brown',
    name: 'Kahve Diyarı',
    category: 'cafe',
    primary: '#4A2C20',
    secondary: '#7B4F3A',
    accent: '#D4A574',
    bg: '#F4EDE4',
    surface: '#FFFAF5',
    text: '#2B1810',
    textMuted: '#7A5C4E',
    font: 'Merriweather',
    bodyFont: 'Quicksand',
    layout: 'list',
    headerStyle: 'coffee-bean',
    cardStyle: 'warm-bg',
    cardVariant: 'paper',
    borderRadius: '10px',
    shadow: 'md',
  },
  {
    id: 'latte-beige',
    name: 'Latte Bej',
    category: 'cafe',
    primary: '#A0826D',
    secondary: '#C9B8A4',
    accent: '#6B4226',
    bg: '#FAF6F0',
    surface: '#FFFFFF',
    text: '#3D2817',
    textMuted: '#8B7766',
    font: 'Merriweather',
    bodyFont: 'Quicksand',
    layout: 'grid',
    headerStyle: 'minimal-script',
    cardStyle: 'soft-shadow',
    cardVariant: 'editorial',
    borderRadius: '16px',
    shadow: 'sm',
  },
  {
    id: 'pastel-pink',
    name: 'Pastel Pembe',
    category: 'cafe',
    primary: '#E91E63',
    secondary: '#F48FB1',
    accent: '#FCE4EC',
    bg: '#FFF5F8',
    surface: '#FFFFFF',
    text: '#4A1530',
    textMuted: '#9B7585',
    font: 'Pacifico',
    bodyFont: 'Inter',
    layout: 'grid',
    headerStyle: 'cute-script',
    cardStyle: 'rounded-pastel',
    cardVariant: 'retro-pop',
    borderRadius: '20px',
    shadow: 'md',
  },
  {
    id: 'scandinavian-mint',
    name: 'İskandinav Nane',
    category: 'cafe',
    primary: '#3DA88E',
    secondary: '#8FD4C0',
    accent: '#FFD166',
    bg: '#F7FBF9',
    surface: '#FFFFFF',
    text: '#1F3D34',
    textMuted: '#6E8B82',
    font: 'Nunito',
    bodyFont: 'Nunito',
    layout: 'list',
    headerStyle: 'minimal-sans',
    cardStyle: 'flat-card',
    cardVariant: 'minimalist-mono',
    borderRadius: '8px',
    shadow: 'sm',
  },
  {
    id: 'woodland-green',
    name: 'Orman Yeşili',
    category: 'cafe',
    primary: '#386641',
    secondary: '#6A994E',
    accent: '#BC4749',
    bg: '#F2EFE4',
    surface: '#FBF8EE',
    text: '#1D3520',
    textMuted: '#5C7561',
    font: 'Lora',
    bodyFont: 'Lora',
    layout: 'list',
    headerStyle: 'organic-divider',
    cardStyle: 'natural-bg',
    cardVariant: 'paper',
    borderRadius: '6px',
    shadow: 'sm',
  },

  // ─── FAST FOOD ───
  {
    id: 'fast-food-red',
    name: 'Hızlı Yemek Kırmızı',
    category: 'fastfood',
    primary: '#DC2626',
    secondary: '#FACC15',
    accent: '#FFFFFF',
    bg: '#FFFBEB',
    surface: '#FFFFFF',
    text: '#1F1F1F',
    textMuted: '#525252',
    font: 'Bebas Neue',
    bodyFont: 'Poppins',
    layout: 'grid',
    headerStyle: 'bold-banner',
    cardStyle: 'punch-card',
    cardVariant: 'neo-brutalist',
    borderRadius: '12px',
    shadow: 'lg',
  },
  {
    id: 'burger-yellow',
    name: 'Burger Sarı',
    category: 'fastfood',
    primary: '#F59E0B',
    secondary: '#DC2626',
    accent: '#1F2937',
    bg: '#FFFBE6',
    surface: '#FFFFFF',
    text: '#1F2937',
    textMuted: '#6B7280',
    font: 'Bebas Neue',
    bodyFont: 'Poppins',
    layout: 'grid',
    headerStyle: 'comic-style',
    cardStyle: 'bold-border',
    cardVariant: 'neo-brutalist',
    borderRadius: '8px',
    shadow: 'md',
  },
  {
    id: 'neon-night',
    name: 'Neon Gece',
    category: 'fastfood',
    dark: true,
    primary: '#00FFFF',
    secondary: '#FF00FF',
    accent: '#FFFF00',
    bg: '#0A0E27',
    surface: '#161A3A',
    text: '#FFFFFF',
    textMuted: '#A0A8C0',
    font: 'Orbitron',
    bodyFont: 'Inter',
    layout: 'grid',
    headerStyle: 'neon-glow',
    cardStyle: 'glow-border',
    cardVariant: 'gradient-glow',
    borderRadius: '4px',
    shadow: 'glow',
  },
  {
    id: 'retro-diner',
    name: 'Retro Lokanta',
    category: 'fastfood',
    primary: '#E63946',
    secondary: '#F1FAEE',
    accent: '#1D3557',
    bg: '#F1FAEE',
    surface: '#FFFFFF',
    text: '#1D3557',
    textMuted: '#457B9D',
    font: 'Lobster',
    bodyFont: 'Lato',
    layout: 'list',
    headerStyle: 'checkered-strip',
    cardStyle: 'retro-stripes',
    cardVariant: 'retro-pop',
    borderRadius: '4px',
    shadow: 'md',
  },

  // ─── MODERN / MİNİMAL ───
  {
    id: 'minimal-white',
    name: 'Minimal Beyaz',
    category: 'modern',
    primary: '#000000',
    secondary: '#525252',
    accent: '#0EA5E9',
    bg: '#FFFFFF',
    surface: '#FAFAFA',
    text: '#171717',
    textMuted: '#737373',
    font: 'Inter',
    bodyFont: 'Inter',
    layout: 'list',
    headerStyle: 'thin-line',
    cardStyle: 'minimal-divider',
    cardVariant: 'minimalist-mono',
    borderRadius: '0px',
    shadow: 'none',
  },
  {
    id: 'mono-black',
    name: 'Mono Siyah',
    category: 'modern',
    dark: true,
    primary: '#FFFFFF',
    secondary: '#A3A3A3',
    accent: '#FACC15',
    bg: '#0A0A0A',
    surface: '#1A1A1A',
    text: '#FAFAFA',
    textMuted: '#A3A3A3',
    font: 'JetBrains Mono',
    bodyFont: 'JetBrains Mono',
    layout: 'list',
    headerStyle: 'mono-block',
    cardStyle: 'mono-card',
    cardVariant: 'minimalist-mono',
    borderRadius: '0px',
    shadow: 'none',
  },
  {
    id: 'glass-morph',
    name: 'Cam Efekti',
    category: 'modern',
    dark: true,
    primary: '#7C3AED',
    secondary: '#A78BFA',
    accent: '#F0ABFC',
    bg: 'linear-gradient(135deg, #667EEA 0%, #764BA2 100%)',
    surface: 'rgba(0,0,0,0.35)',
    text: '#FFFFFF',
    textMuted: '#F0F0FA',
    font: 'Outfit',
    bodyFont: 'Outfit',
    layout: 'grid',
    headerStyle: 'glass-bar',
    cardStyle: 'glass-card',
    cardVariant: 'glass',
    borderRadius: '20px',
    shadow: 'glass',
  },
  {
    id: 'gradient-purple',
    name: 'Mor Gradient',
    category: 'modern',
    primary: '#9333EA',
    secondary: '#EC4899',
    accent: '#FBBF24',
    bg: 'linear-gradient(180deg, #FAF5FF 0%, #FCE7F3 100%)',
    surface: '#FFFFFF',
    text: '#3B0764',
    textMuted: '#7E22CE',
    font: 'Outfit',
    bodyFont: 'Outfit',
    layout: 'grid',
    headerStyle: 'gradient-header',
    cardStyle: 'gradient-card',
    cardVariant: 'gradient-glow',
    borderRadius: '16px',
    shadow: 'lg',
  },

  // ─── TROPİKAL / YAZ ───
  {
    id: 'tropical-paradise',
    name: 'Tropik Cennet',
    category: 'tropical',
    primary: '#059669',
    secondary: '#F59E0B',
    accent: '#EC4899',
    bg: '#ECFDF5',
    surface: '#FFFFFF',
    text: '#064E3B',
    textMuted: '#047857',
    font: 'Pacifico',
    bodyFont: 'Quicksand',
    layout: 'grid',
    headerStyle: 'leaf-bg',
    cardStyle: 'tropical-card',
    cardVariant: 'gradient-glow',
    borderRadius: '24px',
    shadow: 'lg',
  },
  {
    id: 'ocean-breeze',
    name: 'Okyanus Esintisi',
    category: 'tropical',
    primary: '#0891B2',
    secondary: '#06B6D4',
    accent: '#F97316',
    bg: '#ECFEFF',
    surface: '#FFFFFF',
    text: '#164E63',
    textMuted: '#0E7490',
    font: 'Quicksand',
    bodyFont: 'Quicksand',
    layout: 'list',
    headerStyle: 'wave-pattern',
    cardStyle: 'wave-card',
    cardVariant: 'glass',
    borderRadius: '14px',
    shadow: 'md',
  },
  {
    id: 'sunset-orange',
    name: 'Gün Batımı',
    category: 'tropical',
    primary: '#EA580C',
    secondary: '#F97316',
    accent: '#7C2D12',
    bg: 'linear-gradient(180deg, #FED7AA 0%, #FECACA 100%)',
    surface: '#FFFFFF',
    text: '#431407',
    textMuted: '#9A3412',
    font: 'Pacifico',
    bodyFont: 'Quicksand',
    layout: 'grid',
    headerStyle: 'sunset-gradient',
    cardStyle: 'sunset-card',
    cardVariant: 'gradient-glow',
    borderRadius: '18px',
    shadow: 'lg',
  },

  // ─── TATLI / PASTANE ───
  {
    id: 'bakery-cream',
    name: 'Pastane Kreması',
    category: 'bakery',
    primary: '#92400E',
    secondary: '#D97706',
    accent: '#FDE68A',
    bg: '#FFFBEB',
    surface: '#FFFFFF',
    text: '#451A03',
    textMuted: '#92400E',
    font: 'Caveat',
    bodyFont: 'Inter',
    layout: 'grid',
    headerStyle: 'cake-deco',
    cardStyle: 'sweet-card',
    cardVariant: 'paper',
    borderRadius: '16px',
    shadow: 'md',
  },
  {
    id: 'dessert-pastel',
    name: 'Tatlı Pastel',
    category: 'bakery',
    primary: '#F472B6',
    secondary: '#A78BFA',
    accent: '#34D399',
    bg: '#FDF4FF',
    surface: '#FFFFFF',
    text: '#581C87',
    textMuted: '#A855F7',
    font: 'Comfortaa',
    bodyFont: 'Inter',
    layout: 'grid',
    headerStyle: 'soft-script',
    cardStyle: 'soft-shadow',
    cardVariant: 'retro-pop',
    borderRadius: '24px',
    shadow: 'sm',
  },
  {
    id: 'candy-store',
    name: 'Şekerleme',
    category: 'bakery',
    primary: '#DB2777',
    secondary: '#22D3EE',
    accent: '#FACC15',
    bg: 'linear-gradient(135deg, #FCE7F3 0%, #DBEAFE 100%)',
    surface: '#FFFFFF',
    text: '#831843',
    textMuted: '#DB2777',
    font: 'Fredoka',
    bodyFont: 'Inter',
    layout: 'grid',
    headerStyle: 'candy-stripes',
    cardStyle: 'candy-card',
    cardVariant: 'retro-pop',
    borderRadius: '28px',
    shadow: 'lg',
  },

  // ─── PUB / BAR ───
  {
    id: 'pub-dark',
    name: 'İrlanda Pub',
    category: 'pub',
    dark: true,
    primary: '#14532D',
    secondary: '#854D0E',
    accent: '#FBBF24',
    bg: '#1C1917',
    surface: '#292524',
    text: '#FAFAF9',
    textMuted: '#A8A29E',
    font: 'IM Fell English',
    bodyFont: 'Lato',
    layout: 'list',
    headerStyle: 'pub-banner',
    cardStyle: 'wood-card',
    cardVariant: 'art-deco',
    borderRadius: '4px',
    shadow: 'xl',
  },
  {
    id: 'cocktail-neon',
    name: 'Kokteyl Neon',
    category: 'pub',
    dark: true,
    primary: '#F0ABFC',
    secondary: '#22D3EE',
    accent: '#FBBF24',
    bg: '#18181B',
    surface: '#27272A',
    text: '#FAFAFA',
    textMuted: '#D4D4D8',
    font: 'Italianno',
    bodyFont: 'Inter',
    layout: 'grid',
    headerStyle: 'neon-script',
    cardStyle: 'cocktail-card',
    cardVariant: 'gradient-glow',
    borderRadius: '12px',
    shadow: 'glow',
  },
  {
    id: 'wine-bordeaux',
    name: 'Şarap Bordo',
    category: 'pub',
    primary: '#7F1D1D',
    secondary: '#991B1B',
    accent: '#FCD34D',
    bg: '#FEF2F2',
    surface: '#FFFFFF',
    text: '#450A0A',
    textMuted: '#7F1D1D',
    font: 'Cormorant Garamond',
    bodyFont: 'Lora',
    layout: 'list',
    headerStyle: 'wine-cork',
    cardStyle: 'wine-card',
    cardVariant: 'editorial',
    borderRadius: '2px',
    shadow: 'md',
  },

  // ─── ETNİK ───
  {
    id: 'turkish-traditional',
    name: 'Türk Geleneksel',
    category: 'ethnic',
    primary: '#B91C1C',
    secondary: '#15803D',
    accent: '#EAB308',
    bg: '#FFFBEB',
    surface: '#FFFFFF',
    text: '#1F2937',
    textMuted: '#6B7280',
    font: 'Amiri',
    bodyFont: 'Lato',
    layout: 'list',
    headerStyle: 'ottoman-tile',
    cardStyle: 'tile-bg',
    cardVariant: 'editorial',
    borderRadius: '10px',
    shadow: 'md',
  },
  {
    id: 'asian-zen',
    name: 'Asya Zen',
    category: 'ethnic',
    primary: '#991B1B',
    secondary: '#1F2937',
    accent: '#F59E0B',
    bg: '#FAFAF9',
    surface: '#FFFFFF',
    text: '#1C1917',
    textMuted: '#78716C',
    font: 'Noto Serif JP',
    bodyFont: 'Noto Serif JP',
    layout: 'grid',
    headerStyle: 'bamboo-line',
    cardStyle: 'zen-card',
    cardVariant: 'minimalist-mono',
    borderRadius: '0px',
    shadow: 'sm',
  },

  // ─── MUTFAK TEMALARI ───
  {
    id: 'chinese-imperial',
    name: 'Çin İmparatorluk',
    category: 'ethnic',
    primary: '#DC2626',
    secondary: '#FBBF24',
    accent: '#7F1D1D',
    bg: '#FEF2F2',
    surface: '#FFFFFF',
    text: '#7F1D1D',
    textMuted: '#991B1B',
    font: 'Cinzel',
    bodyFont: 'Noto Serif JP',
    layout: 'grid',
    headerStyle: 'imperial-gold',
    cardStyle: 'lacquer-card',
    cardVariant: 'art-deco',
    borderRadius: '4px',
    shadow: 'lg',
  },
  {
    id: 'japanese-minimal',
    name: 'Japon Minimal',
    category: 'ethnic',
    primary: '#BC002D',
    secondary: '#1E293B',
    accent: '#FFFFFF',
    bg: '#FAFAFA',
    surface: '#FFFFFF',
    text: '#0F172A',
    textMuted: '#475569',
    font: 'Noto Serif JP',
    bodyFont: 'Noto Serif JP',
    layout: 'list',
    headerStyle: 'hinomaru',
    cardStyle: 'washi-paper',
    cardVariant: 'minimalist-mono',
    borderRadius: '0px',
    shadow: 'none',
  },
  {
    id: 'turkish-osmanli',
    name: 'Osmanlı Sarayı',
    category: 'ethnic',
    primary: '#7C2D12',
    secondary: '#CA8A04',
    accent: '#0E7490',
    bg: '#FEF3C7',
    surface: '#FFFBEB',
    text: '#451A03',
    textMuted: '#78716C',
    font: 'Amiri',
    bodyFont: 'Cormorant Garamond',
    layout: 'magazine',
    headerStyle: 'ottoman-arch',
    cardStyle: 'tile-bg',
    cardVariant: 'editorial',
    borderRadius: '12px',
    shadow: 'lg',
  },
  {
    id: 'mexican-fiesta',
    name: 'Meksika Fiesta',
    category: 'ethnic',
    primary: '#EC4899',
    secondary: '#FACC15',
    accent: '#06B6D4',
    bg: '#FDF4FF',
    surface: '#FFFFFF',
    text: '#581C87',
    textMuted: '#7E22CE',
    font: 'Fredoka',
    bodyFont: 'Quicksand',
    layout: 'grid',
    headerStyle: 'papel-picado',
    cardStyle: 'fiesta-card',
    cardVariant: 'retro-pop',
    borderRadius: '20px',
    shadow: 'xl',
  },
  {
    id: 'italian-ristorante',
    name: 'İtalyan Ristorante',
    category: 'ethnic',
    primary: '#15803D',
    secondary: '#DC2626',
    accent: '#FFFFFF',
    bg: '#FEFCE8',
    surface: '#FFFFFF',
    text: '#1F2937',
    textMuted: '#6B7280',
    font: 'Playfair Display',
    bodyFont: 'Lora',
    layout: 'magazine',
    headerStyle: 'trattoria-stripes',
    cardStyle: 'menu-classic',
    cardVariant: 'editorial',
    borderRadius: '6px',
    shadow: 'md',
  },

  // ─── KURUMSAL ───
  {
    id: 'corporate-blue',
    name: 'Kurumsal Mavi',
    category: 'corporate',
    primary: '#1E3A8A',
    secondary: '#3B82F6',
    accent: '#0EA5E9',
    bg: '#F8FAFC',
    surface: '#FFFFFF',
    text: '#0F172A',
    textMuted: '#64748B',
    font: 'Inter',
    bodyFont: 'Inter',
    layout: 'list',
    headerStyle: 'corporate-bar',
    cardStyle: 'card-clean',
    cardVariant: 'minimalist-mono',
    borderRadius: '8px',
    shadow: 'sm',
  },
  {
    id: 'corporate-luxury',
    name: 'Kurumsal Lüks',
    category: 'corporate',
    primary: '#000000',
    secondary: '#D4AF37',
    accent: '#92400E',
    bg: '#0A0A0A',
    surface: '#1A1A1A',
    text: '#FAFAF9',
    textMuted: '#D4D4D8',
    font: 'Cinzel',
    bodyFont: 'Cormorant Garamond',
    layout: 'magazine',
    headerStyle: 'gold-frame',
    cardStyle: 'lux-card',
    cardVariant: 'art-deco',
    borderRadius: '2px',
    shadow: 'xl',
    dark: true,
  },

  // ─── EK MUTFAK TEMALARI ───
  {
    id: 'indian-spice',
    name: 'Hint Baharatlı',
    category: 'ethnic',
    primary: '#EA580C',
    secondary: '#DC2626',
    accent: '#FBBF24',
    bg: '#FFF7ED',
    surface: '#FFFBEB',
    text: '#7C2D12',
    textMuted: '#9A3412',
    font: 'Cinzel',
    bodyFont: 'Lora',
    layout: 'magazine',
    headerStyle: 'mandala',
    cardStyle: 'spice-card',
    cardVariant: 'editorial',
    borderRadius: '14px',
    shadow: 'lg',
  },
  {
    id: 'greek-aegean',
    name: 'Yunan Ege',
    category: 'ethnic',
    primary: '#0284C7',
    secondary: '#FFFFFF',
    accent: '#0E7490',
    bg: '#F0F9FF',
    surface: '#FFFFFF',
    text: '#0C4A6E',
    textMuted: '#0369A1',
    font: 'Cormorant Garamond',
    bodyFont: 'Lato',
    layout: 'grid',
    headerStyle: 'santorini',
    cardStyle: 'whitewash-card',
    cardVariant: 'minimalist-mono',
    borderRadius: '6px',
    shadow: 'md',
  },
  {
    id: 'french-bistro',
    name: 'Fransız Bistro',
    category: 'ethnic',
    primary: '#1E40AF',
    secondary: '#B91C1C',
    accent: '#FAFAFA',
    bg: '#FAFAFA',
    surface: '#FFFFFF',
    text: '#1F2937',
    textMuted: '#6B7280',
    font: 'Playfair Display',
    bodyFont: 'Cormorant Garamond',
    layout: 'magazine',
    headerStyle: 'belle-epoque',
    cardStyle: 'parisian-card',
    cardVariant: 'editorial',
    borderRadius: '4px',
    shadow: 'md',
  },
  {
    id: 'american-bbq',
    name: 'Amerikan BBQ',
    category: 'ethnic',
    primary: '#7F1D1D',
    secondary: '#92400E',
    accent: '#FACC15',
    bg: '#1C1917',
    surface: '#292524',
    text: '#FAFAF9',
    textMuted: '#D6D3D1',
    font: 'Bebas Neue',
    bodyFont: 'Quicksand',
    layout: 'grid',
    headerStyle: 'smokehouse',
    cardStyle: 'rustic-wood',
    cardVariant: 'neo-brutalist',
    borderRadius: '0px',
    shadow: 'xl',
    dark: true,
  },
  {
    id: 'thai-tropical',
    name: 'Tay Tropikal',
    category: 'ethnic',
    primary: '#10B981',
    secondary: '#F59E0B',
    accent: '#EF4444',
    bg: '#ECFDF5',
    surface: '#F0FDF4',
    text: '#064E3B',
    textMuted: '#047857',
    font: 'Quicksand',
    bodyFont: 'Nunito',
    layout: 'grid',
    headerStyle: 'jungle-leaves',
    cardStyle: 'palm-card',
    cardVariant: 'gradient-glow',
    borderRadius: '16px',
    shadow: 'lg',
  },
  {
    id: 'lebanese-mezze',
    name: 'Lübnan Meze',
    category: 'ethnic',
    primary: '#15803D',
    secondary: '#CA8A04',
    accent: '#B91C1C',
    bg: '#F0FDF4',
    surface: '#FFFFFF',
    text: '#14532D',
    textMuted: '#166534',
    font: 'Amiri',
    bodyFont: 'Lora',
    layout: 'magazine',
    headerStyle: 'mediterranean-arch',
    cardStyle: 'olive-card',
    cardVariant: 'editorial',
    borderRadius: '10px',
    shadow: 'md',
  },
  {
    id: 'korean-modern',
    name: 'Kore Modern',
    category: 'ethnic',
    primary: '#0F172A',
    secondary: '#DC2626',
    accent: '#3B82F6',
    bg: '#FAFAFA',
    surface: '#FFFFFF',
    text: '#0F172A',
    textMuted: '#475569',
    font: 'Noto Serif JP',
    bodyFont: 'Inter',
    layout: 'list',
    headerStyle: 'hanok-line',
    cardStyle: 'kpop-card',
    cardVariant: 'minimalist-mono',
    borderRadius: '2px',
    shadow: 'sm',
  },
];

// Tema id ile bul (default: classic-cream)
export function getThemeById(id) {
  return QR_MENU_THEMES.find((t) => t.id === id) || QR_MENU_THEMES[0];
}

// Tema CSS değişkenlerine dönüş
// --qm-font        → body font (paragraf/buton — okunabilir)
// --qm-font-heading → heading font (h1/h2/h3 — dekoratif olabilir)
// Shadow profilleri — sm/md/lg/xl/glow/glass/none → CSS box-shadow
const SHADOW_MAP = {
  none:  'none',
  sm:    '0 1px 2px 0 rgba(0,0,0,0.05)',
  md:    '0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -2px rgba(0,0,0,0.06)',
  lg:    '0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -4px rgba(0,0,0,0.05)',
  xl:    '0 20px 25px -5px rgba(0,0,0,0.18), 0 8px 10px -6px rgba(0,0,0,0.1)',
  glow:  '0 0 24px -4px var(--qm-primary, #0D9488), 0 0 8px rgba(255,255,255,0.1)',
  glass: '0 8px 32px 0 rgba(31,38,135,0.18), inset 0 1px 0 rgba(255,255,255,0.2)',
};

export function themeToCSSVars(theme, overrides = {}) {
  if (!theme) return {};
  const t = { ...theme, ...overrides };
  const bodyFont = t.bodyFont || t.font;
  const headingFont = t.font || t.bodyFont;
  const shadowCss = SHADOW_MAP[t.shadow] || SHADOW_MAP.md;
  return {
    '--qm-primary': t.primary,
    '--qm-secondary': t.secondary,
    '--qm-accent': t.accent,
    '--qm-bg': t.bg,
    '--qm-surface': t.surface,
    '--qm-text': t.text,
    '--qm-text-muted': t.textMuted,
    '--qm-radius': t.borderRadius,
    '--qm-font': `'${bodyFont}', system-ui, sans-serif`,
    '--qm-font-heading': `'${headingFont}', 'Playfair Display', Georgia, serif`,
    '--qm-shadow': shadowCss,
    '--qm-card-style': t.cardStyle || 'flat-card',
    '--qm-card-variant': t.cardVariant || 'paper',
  };
}

// Kategori grupları (UI gruplama için)
export const THEME_CATEGORIES = [
  { id: 'classic',  name: 'Klasik / Restoran',     i18nKey: 'qrThemeCatClassic',  icon: '🍷' },
  { id: 'cafe',     name: 'Kafe / Coffee Shop',    i18nKey: 'qrThemeCatCafe',     icon: '☕' },
  { id: 'fastfood', name: 'Fast Food',             i18nKey: 'qrThemeCatFastFood', icon: '🍔' },
  { id: 'modern',   name: 'Modern / Minimalist',   i18nKey: 'qrThemeCatModern',   icon: '◻' },
  { id: 'tropical', name: 'Tropikal / Yaz',        i18nKey: 'qrThemeCatTropical', icon: '🌴' },
  { id: 'bakery',   name: 'Tatlı / Pastane',       i18nKey: 'qrThemeCatBakery',   icon: '🧁' },
  { id: 'pub',      name: 'Pub / Bar',             i18nKey: 'qrThemeCatPub',      icon: '🍺' },
  { id: 'ethnic',   name: 'Etnik / Mutfak',        i18nKey: 'qrThemeCatEthnic',   icon: '🍱' },
  { id: 'corporate', name: 'Kurumsal',             i18nKey: 'qrThemeCatCorporate', icon: '🏢' },
];

// Google Fonts CDN import için (QRMenu.js'te eklenecek)
// NOT: Hem heading hem body fontları kapsar — okunabilir sans/serif body fontları dahildir.
export const THEME_FONT_LINKS = [
  'Inter:wght@400;500;600;700',
  'Playfair+Display:wght@400;600;700',
  'Cormorant+Garamond:wght@400;500;700',
  'Cinzel:wght@400;600;700',
  'Lato:wght@400;700',
  'Merriweather:wght@400;700',
  'Quicksand:wght@400;500;700',
  'Pacifico',
  'Nunito:wght@400;600;700',
  'Lora:wght@400;500;700',
  'Poppins:wght@400;600;700',
  'Bebas+Neue',
  'Orbitron:wght@400;700',
  'Lobster',
  'JetBrains+Mono:wght@400;700',
  'Outfit:wght@400;600;700',
  'Caveat:wght@400;700',
  'Comfortaa:wght@400;700',
  'Fredoka:wght@400;600;700',
  'IM+Fell+English',
  'Italianno',
  'Amiri:wght@400;700',
  'Noto+Serif+JP:wght@400;700',
];
